import templateReplace from 'es6-template-strings';
import React from 'react';
import { object } from 'prop-types';
import { withRouter } from 'react-router';
import { NavLink } from 'react-router-dom';

import { get } from 'ravenjs/utils/lodash';

import { USER_LOOKUP } from 'constants/tickets';

function TicketsField(props) {
    const { row, history } = props;
    const openCaseCount = get(row, 'openCaseCount', null);
    const submittedCaseCount = get(row, 'submittedCaseCount', null);
    return (
        <NavLink
            key={row.id}
            to={
                history.location?.pathname.includes('/case-cave')
                    ? `/case-cave/cases?caseUserId=${row.userId}`
                    : `/ticketing/tickets?ticket_group=all&user_id=${row.userId}`
            }
        >
            {templateReplace(USER_LOOKUP.CASES.CASE_COUNTS, {
                openCaseCount,
                submittedCaseCount,
            })}
        </NavLink>
    );
}

TicketsField.propTypes = {
    history: object.isRequired,
    row: object,
};

TicketsField.defaultProps = {
    row: {},
};

export { TicketsField as TicketsFieldUnwrapped };
export default withRouter(TicketsField);
